import { FormattedMessage } from 'react-intl'
import { NavLink } from 'react-router-dom'

import { StyledLink } from 'components/v2/Link'
import Card from '@10xLabs/react-web/components/Card'
import { FormattedNumber } from '@10xLabs/react-web/components/FormattedNumber'
import { FormattedPrice } from '@10xLabs/react-web/components/FormattedPrice'
import { getTimeframeDates, TIMEFRAMES } from 'features/SitesSales/components/Filters'
import { Header, Title, Content, Table, Th, Tr, Td } from '../TopList'

const getTimeframeQuery = (timeframe: TSFixMe): TSFixMe => {
  let timeframeDates

  switch (timeframe) {
    case TIMEFRAMES.ONE_YEAR:
    case TIMEFRAMES.ONE_MONTH:
      timeframeDates = getTimeframeDates(timeframe)
      return `purchaseDateFrom=${timeframeDates.from}&purchaseDateTo=${timeframeDates.to}`
    default:
      return `purchaseDateRangeValue=${timeframe}`
  }
}

export const TopSites = ({ sites, filters }: TSFixMe): TSFixMe => {
  return (
    <Card.Container>
      <Header>
        <Title>
          <FormattedMessage id="sites.dashboard.topSites.label" defaultMessage="Top point of sale" />
        </Title>
      </Header>

      <Content>
        <Table>
          <thead>
            <tr>
              <Th>
                <FormattedMessage id="sites.dashboard.topSites.name" defaultMessage="Name" />
              </Th>

              <Th>
                <FormattedMessage id="sites.dashboard.topSites.company" defaultMessage="Company" />
              </Th>

              <Th>
                <FormattedMessage id="sites.dashboard.topSites.sales" defaultMessage="Sales" />
              </Th>

              <Th>
                <FormattedMessage id="sites.dashboard.topSites.gross" defaultMessage="Gross" />
              </Th>
            </tr>
          </thead>

          <tbody>
            {sites.map((site: TSFixMe, index: TSFixMe): TSFixMe => {
              return (
                <Tr key={index}>
                  <Td>{site.name}</Td>

                  <Td>{site.company}</Td>

                  <Td>
                    <StyledLink as={NavLink} to={`/bookings?site=${site.id}&${getTimeframeQuery(filters.timeframe)}`}>
                      <FormattedNumber value={site.count} />
                    </StyledLink>
                  </Td>

                  <Td>
                    <FormattedPrice value={site.amount} />
                  </Td>
                </Tr>
              )
            })}
          </tbody>
        </Table>
      </Content>
    </Card.Container>
  )
}
